<template>
	<div>
		<div class="jiufen">
			<div class="jiufenC">网络文化经营内容自审管理制度</div>
			<div class="jiufneCint">为加强网络文化内容建设与管理，规范网络文化经营单位产品及服务内容自审工作，增强本公司自主管理能力和自律责任，确保网络文化健康，根据《互联网文化管理暂行规定》，结合本单位发展需要及实际情况，制定如下网络文化建设与管理制度。</div>
			<div class="jiufneCint">一．审查机构</div>
			<div class="jiufneCint">1. 内容自审机构的组成</div>
			<div class="jiufneCint">根据文化部制定的《网络文化经营单位内容自审管理办法》，单位将由3名政治敏感性较强、思想上有独特见解的人员组成自审部门，包括总负责人一名，自审员两名。自审部门的审核人员需通过文化部培训，取得《内容审核人员证书》。</div>
			<div class="jiufneCint">自审部门的自审员，主要负责网络文化产品及服务内容的审核。</div>
			<div class="jiufneCint">自审部门的总负责人，主要负责自审工作的的最后审核，包括对网络文化产品及服务内容合法性的准确判断等。</div>
			<div class="jiufneCint">2. 自审人员的职责</div>
			<div class="jiufneCint">1）掌握内容审核的政策法规和相关知识</div>
			<div class="jiufneCint">2）独立表达审核意见</div>
			<div class="jiufneCint">3）参加文化行政部门组织的业务培训</div>
			<div class="jiufneCint">4）以最终保证本企业的产品和服务的合法性和合规性为目的，对在自身工作中发现的违法违规的产品及服务内容进行记录并提请终止，作出提交修改，督促修改，复审等审核意见，重大问题向广西省文化委员会报告；</div>
			<div class="jiufneCint">5）负责保管审查记录；</div>
			<div class="jiufneCint">6）对产品及服务内容的合法合规性不能准确判断的，可向广西省文化委员会申请行政指导；</div>
			<div class="jiufneCint">7）每年应至少参加1次由广西省文化委员会组织的业务培训；</div>
			<div class="jiufneCint">8）组织内部培训工作，对企业开发、运营人员进行内容审查方面的培训。</div>
			<div class="jiufneCint">二、审查流程</div>
			<div class="jiufneCint">1. 对企业自主研发的产品，在研发阶段进行培训，对故事背景、美术素材等进行初步的筛查；</div>
			<div class="jiufneCint">2. 自审人员在产品公测之前，依据内容审查的相关规定，对产品及其服务内容（包括宣传推广和活动策划）进行审查，对违法违规的内容进行记录，并签发初审意见；</div>
			<div class="jiufneCint">3. 对初审有问题的产品，退回研发企业或部门进行修改，并对修改后的内容进行复查；</div>
			<div class="jiufneCint">4. 对内容的合法合规性不能准确判断的，应向广西省文化委员会申请行政指导；</div>
			<div class="jiufneCint">5. 对复查仍有问题的，应按照上述第2-4项规定的内容重新进行审核；</div>
			<div class="jiufneCint">6. 在产品公测前，对产品客户端、公司官网、产品官网进行审查，审查内容包括证照使用、实名注册、实名信息补填、用户协议必备条款、适龄提示、家长监护工程等内容，合格后方可公测；</div>
			<div class="jiufneCint">7. 对审查完成的产品，自审人员提出同意进行公测的意见并签字确认，上交内容审查管理工作的主要负责人；</div>
			<div class="jiufneCint">8. 内容审查管理工作的主要负责人签字确认后，根据规定要求，向文化行政管理部门提交产品备案；</div>
			<div class="jiufneCint">9. 日常对产品和服务内容进行监督检查，包括产品版本更新后的内容、产品客户端、公司官网、产品官网、宣传推广和活动策划等各个方面和环节，发现问题提交检查意见，报本企业内容审查管理工作主要负责人；</div>
			<div class="jiufneCint">10. 自审人员的所有审查意见应归档留存，保存时间不少于两年；</div>
			<div class="jiufneCint">三、审查标准</div>
			<div class="jiufneCint">演出剧（节）目、表演中不得含有以下内容：</div>
			<div class="jiufneCint">1. 表演中涉黄、涉政、谈论宗教、违法及侵权等敏感话题；</div>
			<div class="jiufneCint">2. 表演内容不得造成强烈的感官、精神刺激，及可致人身心不适的动作、语言、画面和音效。</div>
			<div class="jiufneCint">3. 表演者不得发布包含色情内容的黄色网站链接及淫秽视频内容。</div>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return{
			
		}
	},
	mounted() {
		window.scroll(0, 0); 
	}
}
</script>

<style>

</style>
